import React from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { HOMEPAGE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsHomePage';

import { CAR_PRIZE_DRAW_URL } from './CarPrizeDraw.helpers';
import LocalTexts from './CarPrizeDraw.texts.json';

import styles from './CarPrizeDraw.scss';

const LocalT = new MDText(LocalTexts);

const BANNER_LABEL = LocalTexts.banner.content.replace(/\*/g, '');

export const CarPrizeDrawBanner = () => (
  <Link
    data-thc-style-override
    className={styles.banner}
    onClick={() => HOMEPAGE_SNOW_PLOW_EVENTS.CAR_PRIZE_CLICKED(BANNER_LABEL)}
    to={CAR_PRIZE_DRAW_URL}
  >
    <span className={styles.bannerContent}>{LocalT.translate('banner.content')}</span>
  </Link>
);
